'use strict';

var ajax = require('../../ajax'),
    image = require('./image'),
    productStoreInventory = require('../../storeinventory/product'),
    tooltip = require('../../tooltip'),
    progress = require('../../progress'),
    validator = require('../../validator'),
    util = require('../../util'),
    imagesLoaded = require('imagesloaded'),
	tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium');

/**
 * @function pdpSwatchLazyLoad
 * @description This function is used to lazy load swatches on pdp page
 **/

var pdpSwatchLazyLoad = function() {
    var ffSwatches = document.querySelectorAll('#pdpMain .product-variations .swatchanchor.color')
    var $swatches = $('#pdpMain .product-variations .swatchanchor.color').slice(0);

    $swatches.each(function(i, e){
        //get firefox styles;
        var ffCurSrc;
        var styleprops = getComputedStyle(ffSwatches[i]);
        for(var prop in styleprops){
            if(prop === 'backgroundImage'){
                ffCurSrc = styleprops[prop];
            }
        }  
        
        let $curObj = $(this);
        let curSrc = $curObj.css("background") || $curObj[0].style.backgroundImage || ffCurSrc;
        let $img = $curObj.find('img.hide-swatch');
        let finalBack = $img.data('src');
        if(curSrc && curSrc.indexOf('NO-SWATCH-TAB.svg') == -1 ) {
            $curObj.css('background','url('+finalBack+') round');
            $curObj.attr('data-ll-status', 'loaded');
            $img.attr('data-ll-status', 'loaded');
            $curObj.off('unveil');
        }else if(curSrc && curSrc.indexOf('NO-SWATCH-TAB.svg') >= 0) {
            $curObj.addClass('plpnoswatch-img');
        }
    });

}


/**
 * @function updateContentOnLoad
 * @description This function is used to perform the initial ajax load of the product-variation based on the
 * query-string parameters and current product selection
 * @param {String} href Describes the url of the productVariant being loaded
 **/
var updateContentOnLoad = function (href) {

    // Create a reference to the quickView
    var $quickView = $('#QuickViewDialog');

    ajax.load({
        url: href,
        target: $('#product-content'),
        callback: function () {

            // Re-initialize the PDP
            setProductMainFrameID();
            image.replaceImages();
            validator.init();
            tooltip.init();
            util.giftMessageCharCount();
            util.addPersonalMessage();
            util.updateselect();

            // Bypass loading the image-slider logic on quickView
            imagesLoaded('.product-col-1').on('always', function() {
	            if ($quickView.length >= 0) {
	                image.alternateImageSlider();
	            }
            });
            // When initializing the page, inspect the form-factor to render either a
            // mobile or desktop specific set of images in the thumbnail rail
            image.renderResponsiveThumbnailRailImages(true);
            // Re-enable the image display for this product
            $('#pdp-image-container').css('visibility', 'visible');
            //updateContentOnLoad
            // SC-9916
            $('#pdpMain .swatchanchor img').unveil(0,pdpSwatchLazyLoad);

            //force trigger lazyload
            $(window).resize();
            // if a variation is selected by default, run add overlay function
            var selectedImg = $('#pdpMain .swatches.color').find('.selected').find('a').attr('data-lgimg');
            if (selectedImg !== undefined) {
                var largeImg = JSON.parse(selectedImg);
                if (largeImg.isimagesameasmasterproduct !== undefined && largeImg.isimagesameasmasterproduct === true) {
                    addNoImgOverlay(largeImg.url, true);
                }else {
                    removeNoImgOverlay();
                }
            }
            //SM-6400 (Pre-select Color AND/OR Size on PDP when only 1 available)
            var varAttributes = ['size', 'width', 'waist', 'length','braBandSize', 'braCupSize', 'shoeSize', 'shoeWidth'];
            $(varAttributes).each(function() {
            	var curr = this.toLowerCase();
            	if ($('.swatches.'+curr+' li.selectable').length == 1) {
            		$('.swatches.'+curr+' li.selectable:first .swatchanchor').trigger('mouseup');
                }
            });
        }

    });

};

/**
 * @private
 * @function updateContent
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 * @param {Boolean} isKeyEnter - the event is triggered by enter key
 **/

//variables for overlapping ajax call on updateContent
var flag=true,newCallHref,newCallObj,newCallSwatchID,newCallCheck;

var updateContent = function (href, obj, swatchid, isKeyEnter) {
    var viewDetailsUrl,
        updatedhref,
        variationQueryParam,
        $viewDetailsUrl,
        viewDetailsHref,
        baseDetailsUrl,
        queryStringProps,
        $viewDetailsLength = $('#QuickViewDialog a.view-details-link').length,
        $hemmingOptionSelected = $('.hemming-drawer ul li.hemming-option.selected');

    //return if current ajax call is running and set value of new call to varibales
    if(flag!=true){
    	newCallHref=href;
    	newCallObj=obj;
    	newCallSwatchID=swatchid;
    	newCallCheck=true;
    	return;
    }

    //set flag response to prevent another execution
	flag=false;

    // Seed the initial identifiers
    var $pdpForm = $('.pdpForm');

    // Create a reference to the 'view full detail' page url
    if($viewDetailsLength > 0){
        $viewDetailsUrl = $('#QuickViewDialog a.view-details-link');
	    viewDetailsHref = $viewDetailsUrl[0].href;

	    // Find the query-string delimiter in use, and grab the baseUrl
	    if (viewDetailsHref.indexOf('?') !== -1) {
	        baseDetailsUrl = viewDetailsHref.split('?')[0];
	    } else if (viewDetailsHref.indexOf('#') !== -1) {
	        baseDetailsUrl = viewDetailsHref.split('#')[0];
	    } else {
	        baseDetailsUrl = viewDetailsHref;
	    }

	    // updating view details link in quickview
	    if (href.indexOf('source') > -1) {
	        updatedhref = href.split('&source')[0];
	        variationQueryParam = util.getQueryString(updatedhref);
	        queryStringProps = variationQueryParam;
	    } else {
	        queryStringProps = util.getQueryString(href);
	    }

	    // Use a hash to delimit the query-string properties -- and keep
	    // the existing base url (we want the .html url notation vs. pipeline)
	    viewDetailsUrl = baseDetailsUrl + '#' + queryStringProps;

	    if($hemmingOptionSelected.length > 0 && viewDetailsUrl.indexOf('&hemmingoption') == -1){
	    	viewDetailsUrl = updateUrlWithHemmingOption(viewDetailsUrl,$pdpForm,swatchid);
	    	viewDetailsUrl = viewDetailsUrl.replace('?','&');
	    }
    }

    var qty = $pdpForm.find('select[name="Quantity"]').first().val();
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val(),
        geCountry: typeof window.scriptLoaderData !== 'undefined' && typeof window.scriptLoaderData.country !== 'undefined' ? window.scriptLoaderData.country : '',
        geCurrency: typeof window.scriptLoaderData !== 'undefined' && typeof window.scriptLoaderData.currency !== 'undefined' ? window.scriptLoaderData.currency : ''
    };
    if($('#targetedOfferId').length){
        params['TargetedOffer_ID'] = $('#targetedOfferId').val();
    }

    if($('.tfc-fitrec-product .tfc-popup-click-open').length){            
        $('#product-content').attr('data-truefit-loaded','true');
    }    

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $('#product-content'),
        callback: function () {

            var $quickView = $('#QuickViewDialog');
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }
            setProductMainFrameID();
            image.replaceImages();
            image.initializeVideo();
            if ($('.ui-dialog.quick-view').is(':visible')) {
            	util.loadSrollForQVProduct();
        	}

            // Bypass loading the image-slider logic on quickView
            imagesLoaded('.product-col-1').on('always', function() {
	            if ($quickView.length >= 0) {
	                image.alternateImageSlider();
	            }
            });

            validator.init();
            tooltip.init();
            util.giftMessageCharCount();
            util.addPersonalMessage();
            if($viewDetailsLength > 0){
            	$('a.view-details-link').attr('href', viewDetailsHref);
            }
            util.updateselect();

            //init True Fit widget
            if($('.tfc-fitrec-product').length > 0 && typeof tfcapi === 'function'){
                tfcapi('calculate');
            }

            // When initializing the page, inspect the form-factor to render either a
            // mobile or desktop specific set of images in the thumbnail rail
            image.renderResponsiveThumbnailRailImages(true);
            
            // SC-9916
            $('#pdpMain .swatchanchor img').unveil(0,pdpSwatchLazyLoad);

            //force trigger lazyload
            $(window).resize();
            if(obj == null){
                obj = $("#product-content").find("[data-swatchid='" + swatchid + "']").data('swatch');
            }
            if ($("#product-content").find("[data-swatchid='" + swatchid + "']").data('lgimg') !== undefined) {
                var lgimg = $("#product-content").find("[data-swatchid='" + swatchid + "']").data('lgimg');
                lgimg = JSON.parse(JSON.stringify(lgimg));
                var isimagesameasmasterproduct = lgimg.isimagesameasmasterproduct;
                var imagename = lgimg.url;
                addNoImgOverlay(imagename, isimagesameasmasterproduct);
                
            }
            if ($("#product-set-list").find("[data-swatchid='" + swatchid + "']").data('lgimg') !== undefined || $(".product-set-addall").find("[data-swatchid='" + swatchid + "']").data('lgimg') !== undefined) {
                var lgimg = $(".product-set-addall").find("[data-swatchid='" + swatchid + "']").data('lgimg');
                var isimagesameasmasterproduct = JSON.parse(JSON.stringify(lgimg)).isimagesameasmasterproduct;
                var imagename = JSON.parse(JSON.stringify(lgimg)).url; 
                addNoImgOverlay(imagename, isimagesameasmasterproduct);
            }

            //Adding Outlet Status in utag data
            if (typeof utag_data != 'undefined') {
            	utag_data.outlet_status = obj ? obj.outlet_status: "";
            }

            triggerTealiumEvent(obj);
            if (isKeyEnter === true) {
                $("#product-content").find("[data-swatchid='" + swatchid + "']").addClass("focus-outline");
            }
            $("#product-content").find("[data-swatchid='" + swatchid + "']").focus();

            //Set flag true for next call
            flag=true;
            //Check if another ajax call had been initialized
            if(newCallCheck==true && newCallSwatchID){
            	newCallHref=$('[data-swatchid='+newCallSwatchID+']').data('href');
            	updateContent(newCallHref, newCallObj, newCallSwatchID, isKeyEnter);
            	newCallCheck=false;
            }
        }
    });
};

//Function to show Truefit recommendation on PDP
function initTrueFitSizeRecommendation(){

    var trueFitProductObj = {products:{}};
    var $recDiv = $('.tfc-fitrec-product');
    var productId = null;

    if($recDiv.data('styleid')){
        productId = $recDiv.data('styleid');
        trueFitProductObj.products[productId] = {
            colorId: $('.tfc-fitrec-product').data('colorid')
        };
    }
    if(typeof tfcapi === 'function'){
        tfcapi('calculate');
    }
}

var noOfVariationAttributes = new Number($('.noOfVariationAttributes').val());

// Function for select size automatically for true-fit
function fitrec_selectSize(size, score) {
    // If we only have one size
    if (noOfVariationAttributes == 2) {
        var $sizeli = $("ul").find("[data-swatchdisplayvalue='" + size + "']");
        if ($sizeli.length > 0 && $sizeli.hasClass('selectable') && !($sizeli.hasClass('selected'))) {
            $sizeli.find('a').trigger('mouseup');
            noOfVariationAttributes = 0;
        }
    } else if (noOfVariationAttributes > 2) {
        var sizes = size.split(" ");
        if (sizes.length === 3) {
            if($(".sizeFamily").length > 0){
                sizes[0] = sizes[0];
                sizes[1] = sizes[1] + ' ' + sizes[2];
            } else if($(".shoeWidth").length > 0) {
                sizes[0] = sizes[0] + ' ' + sizes[1];
                sizes[1] = sizes[2];
            }
        }
        if($(".shoeWidth").length > 0){
            for (var i = 1; i >= 0; i--) {
                var $sizeli = $("ul").find("[data-swatchdisplayvalue='" + sizes[i] + "']");
                if ($sizeli.length > 0 && $sizeli.hasClass('selectable') && !($sizeli.hasClass('selected'))) {
                    $sizeli.find('a').trigger('mouseup');
                    noOfVariationAttributes = 0;
                }
            }
        } else {
            for (var i = 0; i <= 1; i++) {
                var $sizeli = $("ul").find("[data-swatchdisplayvalue='" + sizes[i] + "']");
                if ($sizeli.length > 0 && $sizeli.hasClass('selectable') && !($sizeli.hasClass('selected'))) {
                    $sizeli.find('a').trigger('mouseup');
                    noOfVariationAttributes = 0;
                }
            }
        }
    }
}

// Triggering Tealium Event after loading variations in PDP.
var triggerTealiumEvent = function (obj) {

	var prodID = '', collectionID = '';
	if(obj){
		obj.collection_id = [];
		obj.event_name = "product_interaction";
		obj.product_viewtype = "standard";
        obj.product_item_id = $('.product-variation-content').data('mainframeid');
        obj.mini_sps_id = [];
        obj.uber_sps_id = [];
        obj.mini_sps_id.push("");
        obj.uber_sps_id.push("");
		if( $('.pdp-main').hasClass('specialproductset') ){
			prodID = $('.product-detail').data('prodsetid');
			collectionID = "specialproductset_"+prodID;
			obj.collection_id.push(collectionID);
		}if( $('.pdp-main').hasClass('standardproductset') ){
			prodID = $('.product-detail').data('prodsetid');
			collectionID = "coll_"+prodID;
			obj.collection_id.push(collectionID);
        }
        
        var pids = $("input[name='pid']", ".product-set-item");
        var mpids = $("input[name='mpid']", ".product-set-item");
        if (pids.length > 1 && $('#pdpMain').find('.main-product-set-details').data('containsvariationgroups') === true) {
            obj.product_id = [];
            obj.mini_sps_id = [];
            obj.uber_sps_id = [];
            obj.product_item_id = [];
            obj.product_viewtype = [];
            for (var i=0; i < pids.length; i++) {
                if ($.isNumeric($(pids[i]).val())) {
                    obj.product_id.push($(pids[i]).val());
                }
                else {
                    obj.product_id.push($(mpids[i]).val());
                }

                obj.product_item_id.push($($(".product-set-item")[i]).data("mainframeid"));
                obj.product_viewtype.push("standard");
                obj.mini_sps_id.push($("input[name='pid']", ".pdpForm").val());
                obj.uber_sps_id.push($("input[name='uberSetId']", ".pdpForm").val());
            }
        }
		tealium.triggerEvent(obj);
	}
};

/**
 * @function setProductMainFrameID
 * @description Checks the product variation's markup for a mainFrameID property value, and if it exists
 * the value is displayed in the product-details section of the PDP display
 */
var setProductMainFrameID = function () {
    var $variationContent;
    var mainFrameID;
    var $mainFrameIDDisplay;

    // First, find the variationContent for the current display
    $variationContent = $('.product-variation-content');

    // If it wasn't found -- exit early
    if ($variationContent.length === 0) { return; }

    // Capture the mainframeId
    mainFrameID = $variationContent.data('mainframeid');

    // Attempt to locate the mainframe display
    $mainFrameIDDisplay = $('.product-details-description .details-mainframeid');

    // Was the display found?  If not, exit early
    if ($mainFrameIDDisplay.length === 0) { return; }

    // Otherwise, clear-out the mainframeId display value
    $mainFrameIDDisplay.find('.mainframeid-itemno').text('');

    // Was a valid mainFrameID found?
    if (mainFrameID.length !== 0) {
        // If so, set the mainFrameID value and show the display
        $mainFrameIDDisplay.find('.mainframeid-itemno').text(mainFrameID);
    } else {
        // Otherwise, show the default 'select a color and size' message
        $mainFrameIDDisplay.find('.mainframeid-itemno').text(window.Resources.SELECT_COLOR_SIZE);
    }
};

var updateContentQuickOrder = function (href, pdpform,$elem,isKeyEnter,containerID) {
    var $pdpForm = $(pdpform);
    var qty = $pdpForm.find('input[name="Quantity"]').first().val();
    var params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        source: 'quickorder',
        isquickOrder: $pdpForm.find('input[name="isCQO"]').val(),
        catalogItemNumber: $pdpForm.find('input[name="quickOrderNumber"]').val(),
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val(),
        cqopid : $pdpForm.find('input[name="editedpid"]').val(),
        editLink : $pdpForm.find('input[name="retainUpdateButton"]').val()
    };
    $pdpForm.find('.product-content-quickorder').spinner().start();
    $('.product-content-quickorder').height($('.product-content-quickorder').height())
    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $pdpForm.find('.product-content-quickorder .content-container'),
        callback: function () {
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }
            image.replaceImagesCQO($pdpForm);
            image.alternateImageSliderCQO();
            image.renderResponsiveThumbnailRailImages(true,$pdpForm);
            validator.init();
            tooltip.init();
            util.updateselect();
            if ($('button.add-all-to-cart-quick-order').length > 0) {
                $('button.add-all-to-cart-quick-order').removeAttr('disabled');
                $('.add-all-to-cart-quick-order').find('.add-all-text').removeClass('hide');
                $('.add-all-to-cart-quick-order').find('.select-size-text').addClass('hide');
            }
            // On swatch selection: to open shop now drawer
            if( $pdpForm.find("ul.swatches li.selected").length > 0 && !($(window).width() > 767) ) {
            	if(!$pdpForm.find('.product-variations-toggle').hasClass('open')) {
                    $pdpForm.find('.product-variations-toggle').trigger("click");
                }
            }
            imagesLoaded($pdpForm).on('always', function() {
	  			image.lazyLoadImages($pdpForm.find('img'));
  		    });
            $('.product-content-quickorder').height('auto');
            $('#pdpMain .swatchanchor img').unveil(0,pdpSwatchLazyLoad);
            $.spinner().stop();
            if(isKeyEnter){
                setTimeout(function() {
                    var swatchID = $elem.attr('data-swatchid');
                    $('[data-mpid="'+containerID+'"]').find('[data-swatchid="'+swatchID+'"]').focus().addClass('focus-outline');
                }, 500);                
            }
        }
    });
};

var updateUrlWithHemmingOption = function(url, currentForm, swatch ){
    var hemmingOption = currentForm.find('.hemmingoption').val();
    if(hemmingOption && swatch != 'sizeFamily'){
        return util.appendParamToURL(url, 'hemmingoption', hemmingOption)
    }
    return url;
}
/**
 * add image overlay for missing colorized image
 * @param {string} targetImagename 
 */


var addNoImgOverlay = function (selectedImg, isSameAsMasterProduct) {
    var mainimg = $('#pdp-image-container .main-image img').attr('src');
    if (!mainimg) return;

    //if add overlay when pdp selected img fall back to master image
    if (selectedImg !== undefined && isSameAsMasterProduct === true) {
        if ($(this).closest('.product-col-2').hasClass('product-quickorder-detail')) {
            //quick order

        } else if ($(this).closest('.product-col-2').hasClass('product-set')) {
            //product set

        } else {
            //regular pdp
            $('.main-image').addClass('no-img-overlay');
            $('.thumbnail-link').eq(0).addClass('no-img-overlay');
        }
    } else {
        removeNoImgOverlay();
    }
}

var removeNoImgOverlay = function () {
    $('.main-image').removeClass('no-img-overlay');
    $('.thumbnail-link').eq(0).removeClass('no-img-overlay');
}
// The initValue is used to prevent content-updated during initialization
module.exports = {

    updateContentOnLoad: updateContentOnLoad,
    updateContent: updateContent,
    updateUrlWithHemmingOption: updateUrlWithHemmingOption,
    pdpSwatchLazyLoad:pdpSwatchLazyLoad,
    init: function () {
    	$('body').off('click', '.product-variations-toggle').on('click', '.product-variations-toggle', function (e) {
        	var $this = $(this);
            if ($this.closest('.product-content-quickorder').find('.variation-add-to-cart-content').length > 0) {
            	if ( !$this.hasClass("open") ) {
                    $this.html(Resources.HIDE_OPTIONS);
                    $this.addClass('open');
                    $this.closest('.product-set-item').addClass('product-open');
                    var $variationSwatches = $this.next().find('.swatches.color img.hide-swatch');
                    if (!$variationSwatches.data('ll-status')) {
                        $('#pdpMain .swatchanchor img').unveil(0,pdpSwatchLazyLoad);
                    }
                    if($( window ).width() >= 768 ){
      	         	    var scrollValue=$this.closest('.product-content-quickorder').offset().top - 60;
                    }
                    $('html,body').animate({
                        'scrollTop': scrollValue
                    });
                } else {
                	$this.html(Resources.SHOP_NOW);
                	$this.removeClass('open')
                	$this.closest('.product-set-item').removeClass('product-open');
                	$('html,body').animate({
            			'scrollTop': $this.closest('.product-content-quickorder').offset().top - 60
                	});
                }
            } else if( $this.closest('.product-set-item').length > 0 ) {
            	var $parent = $this.closest('.product-set-item');
            	if(!$parent.hasClass('product-open')) {
            		$parent.addClass('product-open');
            		$parent.find('.product-variations, .showmore-hemming-monogramming,.productset-cartbutton,.availability-web').slideDown();
            		$this.text(Resources.SHOP_NOW_CLOSE);
            		$('html,body').animate({
                        'scrollTop': $parent.find('.product-set-details').offset().top - 60
                    });
            	} else {
            		$parent.removeClass('product-open');
            		$parent.find('.product-variations, .showmore-hemming-monogramming,.productset-cartbutton,.availability-web').slideUp();
            		$this.text(Resources.SHOP_NOW);
            		$('html,body').animate({
                        'scrollTop': $parent.find('.product-set-details').offset().top - 60
                    });
            	}
            } else if ($this.nextAll('.product-variations').length > 0) {
            	$this.toggleClass('open').nextAll('.product-variations').slideToggle();
            	$this.closest('.product-set-item').toggleClass('product-open');
            	$this.toggleClass('open').nextAll('.product-variations').next('.showmore-hemming-monogramming').slideToggle();
            	$this.toggleClass('open').nextAll('.product-variations').closest('.product-set-item').find('.productset-cartbutton,.availability-web').slideToggle();
            }
            util.productSetReadmore();
        });
        // Create a reference to the PDP display
        var $pdpMain = $('#pdpMain');

    if(!("ontouchstart" in document.documentElement)) {
        // hover on swatch - should update main image with swatch image
        $pdpMain.on('mouseenter', '.swatchanchor', function () {
        	var $curObj = $(this),
        		$attrParent = $curObj.closest('.attribute'),
        		$listParent = $curObj.closest('li'),
                swatchText = $listParent.find('.show-attribute-name').text(),
                isfinalsale = $listParent.find('a').attr('data-isfinalsale'),
                imagename = JSON.parse($listParent.find('a').attr('data-lgimg')).url,
                isimagesameasmasterproduct = JSON.parse($listParent.find('a').attr('data-lgimg')).isimagesameasmasterproduct === 'true';
            if (swatchText !== '') {
            	$attrParent.find('.variation-selection-error-msg').hide();
                $attrParent.find('.selected-value').text('').text(swatchText.toLowerCase());
                if (typeof isfinalsale !== 'undefined' && isfinalsale !== null && !$('.s-product-set').length) {   // final sale msg should not be hidden for sps products
                    if(isfinalsale == 'true'){
                        $attrParent.find('.final-sale-color-msg ').show();
                    }
                    else{
                        $attrParent.find('.final-sale-color-msg ').hide();
                    }
                }
                $attrParent.find('.attribute_label>.label').show();
            }
        });

        $pdpMain.on('mouseleave', '.swatchanchor', function () {
        	var $curObj = $(this),
    			$attrParent = $curObj.closest('.attribute'),
                $listSwatch = $curObj.closest('.swatches'),
                $selectedList = $listSwatch.find('li.selected'),
                isfinalsale = $selectedList.children('a').attr('data-isfinalsale'),
                swatchText = $selectedList.find('.show-attribute-name').text();
                
            $attrParent.find('.selected-value').text('');
            !$('.s-product-set').length && $attrParent.find('.final-sale-color-msg ').hide();   // final sale msg should not be hidden for sps products
           
        	if ($selectedList.length > 0) {
                $attrParent.find('.selected-value').text('').text(swatchText.toLowerCase());
                if (typeof isfinalsale !== 'undefined' && isfinalsale !== null && !$('.s-product-set').length) { // final sale msg should not be hidden for sps products
                    if(isfinalsale == 'true'){
                        $attrParent.find('.final-sale-color-msg ').show();
                    }
                    else{
                        $attrParent.find('.final-sale-color-msg ').hide();
                    }
                }
            }
        });

        $pdpMain.off('mouseenter mouseleave', '.swatchanchor.color').on('mouseenter mouseleave', '.swatchanchor.color', function () {
            if($(this).parent('li').hasClass('selected')){
                return;
            }
            if (!$('.product-video-container').is(':visible')) {
                // Initialize local variables
                var largeImg,
                    $swatch,
                    $imgZoom,
                    $psItem,
                    $cqoItem,
                    $psImage,
                    $mainImage,
                    displayType,
                    dataObj;

                // Set initial details
                displayType = 'standardProduct';
                $swatch = $(this);
                var swatch = this;
                var $swatchesList = $swatch.closest('ul');
                largeImg = JSON.parse(swatch.dataset.lgimg);
                // Exit early if a thumb-image is not found
                if (!largeImg) {
                    return;
                }

                // Remove the hi-res property (we don't want to update the zoom image on mouse-over)
                delete largeImg.hires;
                delete largeImg.tile;
                // Look for a product-set item
                $psItem = $swatch.closest('.product-set-item');
                $cqoItem = $swatch.closest('.product-quickorder-detail');

                // Was a productSet item found?
                if ($psItem.length > 0) {
                    // Grab the image for the product-set
                    $psImage = $psItem.find('div.product-set-product-image');

                    // Was a product-set image found?
                    if ($psImage.length > 0) {
                        displayType = 'specialProductSet';
                    } else {
                        displayType = 'productSet';
                    }
                }else if ($cqoItem.length > 0){
                	displayType = 'CQO';
                }

                switch (displayType) {
                

                case 'CQO':

                    // Standard Product / QuickView
                    $mainImage = $swatch.closest('.pdpForm').find('.primary-image-quick-order');

                    // Default the data-object
                    dataObj = {
                        url: $mainImage.attr('src'),
                        alt: $mainImage.attr('alt'),
                        title: $mainImage.attr('title'),
                        isimagesameasmasterproduct: $('.primary-image').attr('data-isimagesameasmasterproduct')
                    };

                    // Store the old data from main image for mouseleave handler
                    swatch.dataset.lgimg = JSON.stringify(dataObj);
                    // Set the main image
                    image.setPSMainImage($mainImage, largeImg);
                    break;

                default:

                    // Standard Product / QuickView
                    $imgZoom = $pdpMain.find('.main-image');
                    $mainImage = $pdpMain.find('.primary-image');

                    // Default the data-object
                    dataObj = {
                        hires: $imgZoom.attr('href'),
                        url: $mainImage.attr('src'),
                        alt: $mainImage.attr('alt'),
                        title: $mainImage.attr('title'),
                        isimagesameasmasterproduct: $('.primary-image').attr('data-isimagesameasmasterproduct')
                    };
                    var hoverSwatchImage = JSON.parse(swatch.dataset.lgimg).url;
                    var isSameAsMasterProduct = JSON.parse(swatch.dataset.lgimg).isimagesameasmasterproduct === 'true' || JSON.parse(swatch.dataset.lgimg).isimagesameasmasterproduct === true;
                    addNoImgOverlay(hoverSwatchImage, isSameAsMasterProduct);
                    
                    // Store the old data from main image for mouseleave handler
                    swatch.dataset.lgimg = JSON.stringify(dataObj);
                    // Set the main image
                    $(".product-bundle .product-image.main-image img").attr("src", "data:,");
                    image.setMainImage(largeImg);
                    break;
                }
            }
        });
    };
        // display error message for not available product .
        $pdpMain.on('click', '#product-content #add-to-cart-disabled, #product-content .wishlist-disabled', function (e) {
            e.preventDefault();
            $('div.product-add-to-cart div.error-message-disabled').show();
        });

        // click on swatch - should replace product content with new variant
        $pdpMain.off('mouseup keyup', '.product-detail .swatchanchor').on('mouseup keyup', '.product-detail .swatchanchor', function (e) {
            e.preventDefault();
            var isKeyEnter = false;
            if(e.type === "keyup"){
                if (e.which !== 13) return;
                isKeyEnter = true;
            }

            var $swatch = $(this),
                largeImg = $swatch.data('lgimg');

            // per FR 313, disable the ability to deselect a color swatch
            if ($(this).parents('li').is('.selected')) {
                return;
            }

            // Don't trigger the variant-ajax request from a productSet / specialProductSet product-detail
            if ($pdpMain.hasClass('standardproductset') || $pdpMain.hasClass('specialproductset')) {
                return;
            }
            
            // Otherwise, trigger the variant update
            updateContent(updateUrlWithHemmingOption($(this).data('href'), $(this).closest('.pdpForm'), $(this).data('swatchtype')), null, $(this).data("swatchid"), isKeyEnter);
            image.setMainImage(largeImg);
        });
      
        // PXSFCC-4096: Add To Wishlist link is not displaying and on clicking the Add To Bag button
        // Out of stock message is displayed in the PDP.
        $(window).load(function () {

            // Don't trigger the variant-ajax request from a productSet / specialProductSet product-detail
            if ($pdpMain.hasClass('standardproductset') || $pdpMain.hasClass('specialproductset')) {
                return;
            }

            var $productVariations = $('.product-variations li.attribute');
            if ($productVariations.find('.selected').length == $productVariations.length && window.location.search != '' && window.location.search.indexOf('dwvar') > -1) {
                updateContent(Urls.productVariation + window.location.search + '&pid=' + $('#pid').val());
            }
        });

        // Click on swatch for quick order - should replace product content with new variant
        $pdpMain.on('click keyup', '.product-quickorder-detail .swatchanchor', function (e) {
            var isKeyEnter = false;
            if(e.type === "keyup"){
                if (e.which !== 13) return;
            }
            e.preventDefault();
            

            if ($(this).closest('li').hasClass('unselectable') || $(this).closest('li').hasClass('selected')) {
                return;
            }
            
            
            isKeyEnter = $(e.currentTarget).hasClass('focus-outline') ? true : false;

            $(this).closest('.swatches').find('.selected').removeClass('selected');
            $(this).closest('li').addClass('selected');
            var containerID = $(this).closest('.product-variations').attr('data-mpid');
            updateContentQuickOrder(updateUrlWithHemmingOption($(this).data('href'), $(this).closest('.pdpForm'), $(this).data('swatchtype')), $(this).closest('.pdpForm'),$(e.currentTarget),isKeyEnter,containerID);
        });

        $pdpMain.on('change', '.product-quickorder-detail .variation-select', function (e) {
            e.preventDefault();

            if ($(this).val().length === 0) {
                return;
            }

            updateContentQuickOrder($(this).val(), $(this).closest('.pdpForm'));
        });

        // Change drop down variation attribute - should replace product content with new variant
        $pdpMain.on('change', '.variation-select', function () {
            // Exit early if this is a quick-order
            if ($(this).val().length === 0 || $('.product-quickorder-detail').length > 0) {
                return;
            }

            var params = {};

            // check if product is a giftcard and add form inputs as params
            if ($('.e-giftcard-detail').length > 0 || $('.giftcard-detail').length > 0) {
                $('.pdpForm input, .pdpForm textarea').each(function () {
                    // Initialize local variables
                    var outputVal;

                    // Is this a checkbox?
                    if ($(this).attr('type') === 'checkbox') {
                        // If so, evaluate if it's checked
                        if ($(this).is(':checked')) {
                            outputVal = 'true';
                        } else {
                            outputVal = 'false';
                        }
                    } else {
                        // Otherwise, default to the fieldValue
                        outputVal = $(this).val();
                    }

                    // Seed the param object with the field and its corresponding value
                    params[$(this).attr('id')] = outputVal;
                });
                flag=true;
            }

            updateContent(util.appendParamsToUrl($(this).val(), params));

        });

        // Init true fit widget on PDP load
        if($('.tfc-fitrec-product').length > 0){
            initTrueFitSizeRecommendation();
            tfcapi('event', 'tfc-fitrec-product', 'success', function(context) {
                if (typeof fitrec_selectSize === 'function') {
                    fitrec_selectSize(context.fitRecommendation.size, context.fitRecommendation.score);
                }
            });
        }
    }
};
